import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SortByAlphaIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sort_by_alpha"}/>
}
